import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ClientGender } from '@fitness-force/enum';

@Component({
  selector: 'client-gender',
  templateUrl: './client-gender.component.html',
  styleUrls: ['./client-gender.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class ClientGenderComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  clientGender: any = ClientGender;

  constructor() {
    // this.clientGender = ClientGender;
  }
  ngOnInit(): void {}
}
